module.exports = require("./tzm.d.ts");